export const LANGUAGE_MAP: Record<string, string> = {
  '.ts': 'typescript',
  '.tsx': 'tsx',
  '.js': 'javascript',
  '.jsx': 'jsx',
  '.rs': 'rust',
  '.py': 'python',
  '.java': 'java',
  '.kt': 'kotlin',
  '.kts': 'kotlin',
  '.go': 'go',
  '.rb': 'ruby',
  '.php': 'php',
  '.cs': 'csharp',
  '.cpp': 'cpp',
  '.cc': 'cpp',
  '.cxx': 'cpp',
  '.c': 'c',
  '.h': 'c',
  '.hpp': 'cpp',
  '.swift': 'swift',
  '.json': 'json',
  '.yaml': 'yaml',
  '.yml': 'yaml',
  '.md': 'markdown',
  '.html': 'markup',
  '.xml': 'markup',
  '.svg': 'markup',
  '.css': 'css',
  '.scss': 'scss',
  '.sass': 'sass',
  '.less': 'less',
  '.sql': 'sql',
  '.sh': 'bash',
  '.bash': 'bash',
  '.zsh': 'bash',
  '.pl': 'perl',
  '.r': 'r',
  '.R': 'r',
  '.scala': 'scala',
  '.hs': 'haskell',
  '.ex': 'elixir',
  '.exs': 'elixir',
  '.dart': 'dart',
  '.lua': 'lua',
  '.toml': 'toml',
  '.ini': 'ini',
  '.conf': 'nginx',
  '.dockerfile': 'docker',
  '.graphql': 'graphql',
  '.gql': 'graphql',
  '.proto': 'protobuf',
  '.ps1': 'powershell',
}

export const MARKDOWN_LANGUAGE_MAP: Record<string, string> = {
  ts: 'typescript',
  typescript: 'typescript',
  tsx: 'tsx',
  js: 'javascript',
  javascript: 'javascript',
  jsx: 'jsx',
  py: 'python',
  python: 'python',
  java: 'java',
  kt: 'kotlin',
  kotlin: 'kotlin',
  rs: 'rust',
  rust: 'rust',
  go: 'go',
  golang: 'go',
  sh: 'bash',
  bash: 'bash',
  shell: 'bash',
  zsh: 'bash',
  html: 'markup',
  xml: 'markup',
  svg: 'markup',
  css: 'css',
  scss: 'scss',
  sass: 'sass',
  less: 'less',
  json: 'json',
  yaml: 'yaml',
  yml: 'yaml',
  toml: 'toml',
  md: 'markdown',
  markdown: 'markdown',
  c: 'c',
  cpp: 'cpp',
  'c++': 'cpp',
  cxx: 'cpp',
  cc: 'cpp',
  cs: 'csharp',
  csharp: 'csharp',
  ruby: 'ruby',
  rb: 'ruby',
  php: 'php',
  swift: 'swift',
  sql: 'sql',
  perl: 'perl',
  pl: 'perl',
  r: 'r',
  scala: 'scala',
  haskell: 'haskell',
  hs: 'haskell',
  elixir: 'elixir',
  ex: 'elixir',
  dart: 'dart',
  lua: 'lua',
  graphql: 'graphql',
  gql: 'graphql',
  proto: 'protobuf',
  protobuf: 'protobuf',
  powershell: 'powershell',
  ps1: 'powershell',
  docker: 'docker',
  dockerfile: 'docker',
  nginx: 'nginx',
  ini: 'ini',
}

export function getLanguageFromPath(path: string): string {
  const lastDot = path.lastIndexOf('.')
  if (lastDot === -1) return 'text'

  const ext = path.substring(lastDot)
  return LANGUAGE_MAP[ext] || 'text'
}

export function getLanguageFromMarkdownFence(fence: string | undefined): string {
  if (!fence) return 'text'

  const normalized = fence.toLowerCase().trim()
  return MARKDOWN_LANGUAGE_MAP[normalized] || 'text'
}
